import { render, staticRenderFns } from "./Nationality.vue?vue&type=template&id=6252fd0e&scoped=true"
import script from "./Nationality.vue?vue&type=script&lang=js"
export * from "./Nationality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6252fd0e",
  null
  
)

export default component.exports